module.exports = __webpack_public_path__ + "701d9c28920e16653108ec3cf9c60935.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-panel-420.webp
// module id = 474
// module chunks = 0